/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.btn-request-packages[_ngcontent-%COMP%]{float:right;margin-right:20px}"];
export { styles as styles };
